
const showLoader = () => {

    return {
        type: 'INTERFACE_SHOW_LOADER'
    }
}

const hideLoader = () => {

    return {
        type: 'INTERFACE_HIDE_LOADER'
    }
}

const setDimension = (key: string, value: number) => {

    return {
        type : 'INTERFACE_SET_HEIGHT',
        payload: {
            key,
            value
        }
    }
}

interface ShowAsyncConfirmOptions {
  title: string
  message: string
  onConfirm: () => void
  onDeny: () => void
}

export const showAsyncConfirm = (options: ShowAsyncConfirmOptions) => {

  const { title, message, onConfirm, onDeny } = options

  return {
    type: 'INTERFACE_ASYNC_CONFIRM_SHOW',
    payload: {
      title,
      message,
      onConfirm,
      onDeny,
    }
  }
}

export const setIsConfirming = (isConfirming: boolean) => {

  return {
    type: 'INTERFACE_ASYNC_CONFIRM_SET_CONFIRMING',
    payload: {
      isConfirming
    }
  }
}

export const setIsDenying = (isDenying: boolean) => {

  return {
    type: 'INTERFACE_ASYNC_CONFIRM_SET_DENYING',
      payload: {
        isDenying
      }
  }
}

export const hideAsyncConfirm = () => {

  return {
    type: 'INTERFACE_ASYNC_CONFIRM_HIDE',
  }
}


export default {
    showLoader,
    hideLoader,
    setDimension,
}
